import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Floatings from './Floatings';
import * as FloatingOutlets from 'components/floatings';

export default function PageFloatings(props) {
  const {
    category,
    floatings,
    ...rest
  } = props;
  return (
    <Floatings
      {...ex('PageFloatings', rest)}
      {...{
        category,
        floatings,
        outlets: FloatingOutlets,
      }}
    />
  );
}
